import { render } from "./mov-pdv-list.vue?vue&type=template&id=2a63a7e3"
import script from "./mov-pdv-list.vue?vue&type=script&lang=js"
export * from "./mov-pdv-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__